/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import React from 'react';
import { formatDateTime } from '../../util/DateUtil';
import moment from 'moment';
import 'moment/locale/es';

const Default = (props) => {
    moment.locale('es');
    const clickOpenEmail = (col, data) => {
        let request = data.uuid;
        if(col.hasOwnProperty('object')){
            request = col.object;
            request[col.objectKey] = data[col.objectKey];
        }

        localStorage.setItem("valueSearch",data[col.emailKey])
        props.addWidget(col.openEmail, request, ['changeEmail'], data[col.emailKey]);
    }

    const clickOpenModal = (col, data) => {
        let request = col.text ? data[col.text] : data.uuid;
        if(col.hasOwnProperty('object')){
            request = col.object;
            request[col.objectKey] = data[col.objectKey];
        }
        //props.addWidget(col.openModal, col.text ? data[col.text] : data.uuid, ['modal', col.emailKey ? 'changeEmail' : ''], data[col.emailKey])
        /*let request = col.text ? data[col.text] : data.uuid;
        if(col.hasOwnProperty('object')){
            request = col.object;
            request[col.objectKey] = data[col.objectKey];
        }*/
        props.addWidget(col.openModal, request, ['modal', col.emailKey ? 'changeEmail' : ''], data[col.emailKey]);
    }

  	return(
		<div className={props.removeClass ? '' : 'size-12'}>
            <div className={props.removeClass ? '' : 'card'}>

            <div className='container-table-default'>
                <table>
                    <thead>
                        <tr>
                            {
                                props.item.data.columns.map((c, ic) => {
                                    if(c.hasOwnProperty('checkbox')){
                                        return <th className="neutral" key={ic}>
                                            <div className='check_in_table'>
                                                <input className="cmn_checkbox" type="checkbox"  name="tableCheckbox"  id={"check-init"}  onChange={props.handleCheckbox.bind(this, {})} checked={props.stateCheckbox['tableCheckbox'] || ""}/>
                                                <label htmlFor={"check-init"}></label>
                                            </div>
                                        </th>
                                    } else {
                                        return <th className="neutral" key={ic}>
                                            {c.name}
                                        </th>
                                    }
                                })
                            }
                            {
                                props.customColumns && props.customColumns.map((c, ic) => {
                                    return <th className="neutral" key={ic}>
                                        {c.header}
                                    </th>
                                })
                            }
                        </tr>
                    </thead>
                    <tbody>
                        {
                            props.item.data.content.map((data, iData) => {
                                return <tr key={iData} id={`${props.rowIdPrefix}${iData}`}>
                                    {
                                        props.item.data.columns.map((c, ic) => {
                                            if(c.hasOwnProperty('moment')){
                                                return <td className="" key={ic}>
                                                    {moment(new Date(data[c.key])).format(c.moment)}
                                                </td>
                                            }
                                            if(c.format === 'formatDateTime' && !data['formatDateTime']) {
                                                data[c.key] = formatDateTime(data[c.key]);
                                                data['formatDateTime'] = true;
                                            }
                                            if(c.hasOwnProperty('checkbox')){
                                                return <td className="" key={ic}>
                                                    <div className='check_in_table'>
                                                        <input className="cmn_checkbox" type="checkbox"  name={data[c.checkbox]}  id={"check-"+iData}  onChange={props.handleCheckbox.bind(this, data)} checked={props.stateCheckbox[data[c.checkbox]] || ""}/>
                                                        <label htmlFor={"check-"+iData}></label>
                                                    </div>
                                                </td>
                                            }
                                            else if(c.hasOwnProperty('radio') && data.type !== "7"){
                                                return <td className=" fx-rw0" key={ic}>
                                                    <div className={`radio_in_table ${data.hidden ? 'hidden' : ''}`}>
                                                        <input className='cmn_radio'  value={data.uuid} name='radio-tbl' type="radio" id={"rad-"+iData} onClick={props.onClickRadio.bind(this, data)} />
                                                        <label htmlFor={"rad-"+iData}>{data[c.key]}</label>
                                                    </div>  
                                                </td>
                                            }
                                            if(c.hasOwnProperty('toogle')){
                                                return <td className="" key={ic}>
                                                    <div className={`switcher mini padding-right desktop fx-switcher-top ${props.stateToogle[data[c.toogle]] ? 'active' : ''}`}
                                                            onClick={props.handleToogle.bind(this, data)}>
                                                        <div className="switcherSlider">
                                                            <div className="switcherSliderCircle"></div>
                                                        </div>
                                                        <label className='col-3 fix-lb-spaces-bloq'></label>
                                                    </div>
                                                </td>
                                            }
                                            else if(c.hasOwnProperty('options') && data.type !== "7"){
                                                return <td className="" key={ic}>
                                                    <span className={`fa fa-ellipsis-v tap fx-mrg-ibon`} onClick={props.options.bind(this, data, iData, props.item.data.columns.length)}></span>
                                                </td>
                                            }
                                            else if(c.hasOwnProperty('download') && props.rowIdPrefix == 'tr-company'){
                                                return <td className="" key={ic}>
                                                    <i className="ibon-download tap inb2 col-2 "onClick={props.download.bind(this, data)}></i>
                                                </td>
                                            }
                                            else if(c.hasOwnProperty('open')){
                                                return <td className="" key={ic}>
                                                    <a href="#" onClick={props.addWidget.bind(this, c.open, data.uuid)}>{data[c.key]}</a>
                                                </td>
                                            }
                                            else if(c.hasOwnProperty('openEmail')){
                                                return <td className="" key={ic}>
                                                    <a href="#" onClick={clickOpenEmail.bind(this, c, data)}>{data[c.key]}</a>
                                                </td>
                                            }
                                            else if(c.hasOwnProperty('openModal')){
                                                return <td className="" key={ic}>
                                                    <a href="#" onClick={clickOpenModal.bind(this, c, data)}>{data[c.key]}</a>
                                                </td>
                                            }
                                            /*else if(c.hasOwnProperty('openModal')){
                                                return <td className="" key={ic}>
                                                    <a href="#" onClick={props.addWidget.bind(this, c.openModal, c.text ? data[c.text] : data.uuid,
                                                        ['modal', c.emailKey ? 'changeEmail' : ''], data[c.emailKey])}>{data[c.key]}</a>
                                                </td>
                                            }*/else{
                                                return <td className="" key={ic}>
                                                    {data[c.key]}
                                                </td>
                                            }
                                            
                                        })
                                    }
                                    {
                                        props.customColumns && props.customColumns.map((c, ic) => {
                                            return <td className="" id={`customColum-${iData}-${ic}`} key={`${iData}-${ic}`}>
                                                {c.html}
                                                <input key={`ih-${iData}-${ic}`} type="hidden" value={data[c.key]}></input>
                                            </td>
                                        })
                                    }
                                </tr>
                            })
                        }
                    </tbody>
                </table>
            </div>
            </div>
        </div>
  	)
}

export default Default;

